import {useSnackbar} from 'notistack';
import {useTranslation} from 'react-i18next';
import React, {useState} from 'react';
import {BillsGroupedAction, invoicesService, InvoiceStatus} from '@store/invoices/invoices';
import {Button, Stack} from '@mui/material';
import ModalComponent from '@components/modal/Modal.component';
import {checkIfErrors, FieldValidationType, getFieldError} from '@utils/yup.utils';
import SelectComponent from '@components/inputs/select/Select.component';
import {Sizes} from '@constants/sizes.constants';
import {finalize} from 'rxjs';

interface BillsGroupedActionModalProps {
  handleClose: () => void;
}

const BillsGroupedActionModal = (props: BillsGroupedActionModalProps) => {
  const {handleClose} = props;

  const {t} = useTranslation();
  const {enqueueSnackbar} = useSnackbar();

  const [loading, setLoading] = useState(false);

  const [data, setData] = useState<BillsGroupedAction>({});

  const errors = {
    status: getFieldError(data.status, FieldValidationType.REQUIRED_STRING),
  };

  const handleSave = () => {
    invoicesService.groupedAction(data)
      .pipe(finalize(() => setLoading(false)))
      .subscribe({
        next: () => {
          enqueueSnackbar(t('global.success'), {variant: 'success'});
          handleClose();
        },
        error: (err) => enqueueSnackbar(err.text, err.options),
      });
  };

  return (<ModalComponent
    title={t('global.groupedAction')}
    handleClose={handleClose}
    content={(
      <Stack width="70%" spacing={2} pt="55px" pb="10px">
        <SelectComponent
          color="secondary"
          labelWidth={Sizes.drawerInputLabelWidth}
          label={t('global.status')}
          placeholder={t('global.select')}
          items={InvoiceStatus.selectItems().filter(s => s.value !== InvoiceStatus.DRAFT)}
          value={data.status}
          handleChange={(status) => setData({...data, status})}
          required
          error={errors.status}
        />
      </Stack>
    )}
    actions={
      <>
        <Button variant="outlined" disabled={loading} onClick={handleClose}>
          {t('global.cancel')}
        </Button>
        <Button
          variant="contained"
          disabled={loading || checkIfErrors(errors)}
          onClick={handleSave}
          color="primary">
          {t('global.save')}
        </Button>
      </>
    }
  />);
};

export default BillsGroupedActionModal;
